import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

function NotFound() {
    return (
        <div className="mx-auto max-w-3xl px-6 py-24 text-center">
            <p className="font-mono text-sm text-muted-foreground">
                zsh: command not found: <span className="text-destructive">{window.location.pathname}</span>
            </p>
            <h1 className="mt-2 text-3xl font-bold tracking-tight">Nothing at this address</h1>
            <p className="mt-3 font-mono text-sm text-muted-foreground">
                did you mean: <Link to="/" className="text-primary underline underline-offset-4">cd ~</Link>
            </p>
            <Button variant="outline" className="mt-8" asChild>
                <Link to="/">
                    <ArrowLeft /> Back to home
                </Link>
            </Button>
        </div>
    );
}

export default NotFound;
